import React from 'react';
import '../styles/badges.css';

/**
 * Reusable Badge component for achievements and status indicators
 * @param {string} type - Badge type: 'leader', 'new-member', 'top-performer', 'most-improved'
 * @param {string} label - Badge text
 * @param {string} icon - Optional emoji or icon
 * @param {string} tooltip - Optional tooltip text
 * @param {boolean} pulse - Whether to show pulse animation
 */
const Badge = ({ type = 'default', label, icon, tooltip, pulse = false }) => {
  const badgeClass = `badge badge-${type} ${pulse ? 'badge-pulse' : ''}`;

  return (
    <span
      className={badgeClass}
      title={tooltip}
      aria-label={tooltip || label}
    >
      {icon && <span className="badge-icon">{icon}</span>}
      <span className="badge-label">{label}</span>
    </span>
  );
};

export default Badge;
